export const ADD_ACCOUNT_MANAGEMENT_CONNECTOR = 'organization/accountmanagementconnectors/ADD'
export const ADD_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS = `${ADD_ACCOUNT_MANAGEMENT_CONNECTOR}_SUCCESS`

export const GET_ACCOUNT_MANAGEMENT_CONNECTOR = 'organization/accountmanagementconnectors/GET'
export const GET_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS = `${GET_ACCOUNT_MANAGEMENT_CONNECTOR}_SUCCESS`

export const REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR = 'organization/accountmanagementconnectors/REMOVE'
export const REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS = `${REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR}_SUCCESS`

export const DELETE_SCIM_TOKEN_KEY = 'organization/scimtoken/DELETE'
export const DELETE_SCIM_TOKEN_KEY_SUCCESS = `${DELETE_SCIM_TOKEN_KEY}_SUCCESS`

export const GET_SCIM_TOKEN_KEY = 'organization/scimtoken/GET'
export const GET_SCIM_TOKEN_KEY_SUCCESS = `${GET_SCIM_TOKEN_KEY}_SUCCESS`

export const CLEAR_SCIM_TOKEN_SECRET = 'organization/scimtoken/CLEAR_SCIM_TOKEN_SECRET'

export const CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET =
  'organization/accountmanagementconnectors/CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET'
